// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// TODO NEXT - this is used in bulk edits redux module.
// In an effort to cleanly separate the two modules,
// this should either be a shared util or duplicated.

// returns bool if a path contains an empty
// value based on the filterSelect
const hasEmptyValue = (selectValue, path) => {
  const pathEndHasUnassigned = p => (
    !path.get('site1').getIn(p) ||
    !path.get('site2').getIn(p)
  )

  switch (selectValue) {
    case 'antennaCode' :
    case 'antennaModel' :
      // just check if see if there's a primary assigned, don't look at code or model values.
      return pathEndHasUnassigned(['antennas', 'primary', 'antennaCode'])

    case 'band' :
      return path.get('band') === null

    case 'callSign' :
      return pathEndHasUnassigned(['callSign'])

    case 'radioCode' :
      return pathEndHasUnassigned(['radio', 'radioCode'])

    default :
      // the only way we're here is if the checkbox is checked.
      // if we dont have a selectValue mapped here, that means somehow the user
      // has selected the checkbox when it should be hidden
      // (checkbox conditionally renders based on selectValue)
      console.warn('hasEmptyValue error: unmapped selectValue of ' + selectValue)
      return
  }
}

export default hasEmptyValue
